
export const IMAGE_BASE_URL = import.meta.env.VITE_IMAGEKIT_URL || '/images';

// src/data/dummyData.ts

// ─── Match Card type ────────────────────────────────────
export interface MatchItem {
  id: string;
  team1: string;
  team2: string;
  team1Logo: string;
  team2Logo: string;
  tournament: string;
  time: string;
  isLive?: boolean;
  thumbnail: string;
}

export const ICONS = {
  // Column 1
  menu: { x: 70, y: 95 },
  notification: { x: 70, y: 155 },
  eye: { x: 70, y: 215 },
  live: { x: 70, y: 280 },
  playCircle: { x: 70, y: 340 },
  cricket: { x: 70, y: 400 },
  playSmall: { x: 70, y: 470 },
  help: { x: 70, y: 515 },
  search: { x: 70, y: 570 },

  // Column 2
  bat: { x: 130, y: 95 },
  home: { x: 130, y: 160 },
  whatsapp: { x: 130, y: 215 },
  rugby: { x: 130, y: 280 },
  tennis: { x: 130, y: 340 },
  bangladesh: { x: 130, y: 405 },
  back: { x: 130, y: 470 },
  users: { x: 130, y: 515 },

  // Column 3
  casino: { x: 235, y: 95 },
  cricketBat: { x: 235, y: 155 },
  football: { x: 235, y: 220 },
  badminton: { x: 235, y: 290 },
  close: { x: 235, y: 360 },
  phone: { x: 235, y: 430 },
  user: { x: 235, y: 500 },
  eyeOff: { x: 235, y: 565 },
  eye2: { x: 235, y: 635 },
  info: { x: 235, y: 705 },

  // Column 4
  homeSmall: { x: 380, y: 95 },
  profile: { x: 380, y: 150 },
  cricketGrey: { x: 380, y: 205 },
  settings: { x: 380, y: 260 },
  history: { x: 380, y: 310 },
  medal: { x: 380, y: 380 },
  gift: { x: 380, y: 425 },
  logout: { x: 380, y: 470 },
  helpChat: { x: 380, y: 515 },
  login: { x: 380, y: 575 },
  check: { x: 380, y: 645 },
  closeSmall: { x: 380, y: 690 },
};
export const SPRITE_SIZE = 32;
